import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import App from './app/App';
import './ant.css';
import './ant-overrides.css';
import ConfigService from './shared/services/ConfigService';
import {INotice, Notifier} from '@airbrake/browser';
import {ErrorHandler} from './app/context/ErrorHandler';
import DataService from './shared/services/DataService';

function isBrowserSupported(): boolean {
  // Blacklist IE 10, 9 and 8 based on user agent
  const IE_USER_AGENT_REGEX = /MSIE\s?(\d+)(?:\.(\d+))?/i;

  const matches = navigator.userAgent.match(IE_USER_AGENT_REGEX);
  if (matches != null) {
    if (matches[1] === '10' || matches[1] === '9' || matches[1] === '8') {
      return false;
    }
  }

  return true;
}

if (isBrowserSupported()) {
  ConfigService.loadConfig().then(() => {

    let airbrakeEnv = ConfigService.config.environment.toLowerCase();

    switch (airbrakeEnv) {
      case 'live':
        airbrakeEnv = 'production';
        break;
      case 'test':
        airbrakeEnv = 'staging';
        break;
      default:
    }

    const airbrake = new Notifier({
      projectId: parseInt(ConfigService.config.airbrakeProjectId, 10),
      projectKey: ConfigService.config.airbrakeProjectKey,
      environment: airbrakeEnv
    });

    airbrake.addFilter((notice: INotice) => {
      if (notice.context.environment === 'dev') {
        // Ignore errors from dev
        return null;
      }
      return notice;
    });

    const reportError = (err: Error) => {
      airbrake.notify(err);
    };

    DataService.reportErrorCallback = reportError;

    airbrake.call(
      ReactDOM.render,
      <ErrorHandler.Provider
        value={{
          reportError: reportError
        }}
      >
        <App/>
      </ErrorHandler.Provider>,
      document.getElementById('root') as HTMLElement
    );
  });
} else {
  (document.getElementById('root') as HTMLElement).innerText = 'Sorry, your browser is not supported';
}
